"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackgroundCheckProvider = void 0;
exports.instanceOfBackgroundCheckProvider = instanceOfBackgroundCheckProvider;
exports.BackgroundCheckProviderFromJSON = BackgroundCheckProviderFromJSON;
exports.BackgroundCheckProviderFromJSONTyped = BackgroundCheckProviderFromJSONTyped;
exports.BackgroundCheckProviderToJSON = BackgroundCheckProviderToJSON;
exports.BackgroundCheckProviderToJSONTyped = BackgroundCheckProviderToJSONTyped;
/**
 *
 * @export
 */
exports.BackgroundCheckProvider = {
    Checkr: 'CHECKR',
    Karmacheck: 'KARMACHECK',
    Manual: 'MANUAL'
};
function instanceOfBackgroundCheckProvider(value) {
    for (const key in exports.BackgroundCheckProvider) {
        if (Object.prototype.hasOwnProperty.call(exports.BackgroundCheckProvider, key)) {
            if (exports.BackgroundCheckProvider[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function BackgroundCheckProviderFromJSON(json) {
    return BackgroundCheckProviderFromJSONTyped(json, false);
}
function BackgroundCheckProviderFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function BackgroundCheckProviderToJSON(value) {
    return value;
}
function BackgroundCheckProviderToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=BackgroundCheckProvider.js.map